module.exports = __webpack_public_path__ + "static/media/svg-3.33c05a5e.svg";